/* tslint:disable */
/* eslint-disable */
export enum DisplayAuctionArchiveMode {
  ByYearByDefault = 'by_year_by_default',
  ByYearOnly = 'by_year_only',
  FullByDefault = 'full_by_default',
  FullOnly = 'full_only'
}
